import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms'
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';  // eta linea es para tranferir datos y cerrar dialog



@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css']
})





export class EditorComponent implements OnInit {
editorForm: FormGroup;
htmlContent ='';
public divarea = true;

 config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '10rem',
    maxHeight: '30rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };



  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<EditorComponent>
  ) { }

  ngOnInit() {
console.log ('cosnole', this.data.identificador) ;
    this.htmlContent = this.data.identificador;

    // this.editorForm = new FormGroup({
    //   'editor' : new FormGroup(null)
    // })

  }



  cerrarventana() {
    this.dialogRef.close(this.htmlContent);
  }


}
